import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { routeTargetForIncomingUrl } from '@/utils/publicUrl';

const DEDUPE_MS = 2000;

let lastUrl = '';
let lastAt = 0;

function markHandled(url) {
  const now = Date.now();
  if (url === lastUrl && now - lastAt < DEDUPE_MS) return false;
  lastUrl = url;
  lastAt = now;
  return true;
}

/**
 * Cold start and appUrlOpen share this path.
 * The same URL delivered twice within two seconds navigates once.
 */
export async function openIncomingUrl(router, rawUrl) {
  if (!rawUrl || !markHandled(rawUrl)) return false;
  const target = routeTargetForIncomingUrl(rawUrl);
  if (!target || !router) return false;
  await router.isReady();
  if (router.currentRoute?.value?.fullPath === target) return true;
  await router.replace(target);
  return true;
}

export function ensureUniversalLinkListener(router) {
  if (window.__bstUniversalLinkListener) return;
  if (!Capacitor.isNativePlatform()) return;
  window.__bstUniversalLinkListener = true;
  App.addListener('appUrlOpen', (event) => {
    openIncomingUrl(router, event && event.url);
  });
}

export async function consumeLaunchUrl(router) {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const launch = await App.getLaunchUrl();
    if (!launch || !launch.url) return false;
    return openIncomingUrl(router, launch.url);
  } catch (err) {
    console.error('Universal Link launch URL failed:', err);
    return false;
  }
}
